import { QRCodeCanvas } from 'qrcode.react'
import { Button } from './button'

interface QRCodeProps {
  value: string
  size?: number
  fgColor?: string
  bgColor?: string
  logoUrl?: string
}

export function QRCode({
  value,
  size = 180,
  fgColor = '#0f172a',
  bgColor = '#ffffff',
}: QRCodeProps) {
  const id = `qr-${btoa(value).replace(/=/g, '')}`

  function download() {
    const canvas = document.getElementById(id) as HTMLCanvasElement | null
    if (!canvas) return
    const url = canvas.toDataURL('image/png')
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = 'miaoform-qrcode.png'
    anchor.click()
  }

  return (
    <div className="flex flex-col items-center gap-3">
      <QRCodeCanvas id={id} value={value} size={size} fgColor={fgColor} bgColor={bgColor} />
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={download}
        title="只下載前端 QR PNG 圖檔，非回應資料匯出。"
      >
        下載 QR 圖檔
      </Button>
    </div>
  )
}
